angular.module('dnecom')
    .directive('uploadImagePreview', function () {
        return {
            type: 'E',
            template: '<div class="thumbnail overlayer-wrapper">\n    <img ng-class="{\'blur-5\': markedForDelete}" media-src="media" alt="{{ media.fileName }}">\n    <div ng-class="{\'blur-5\': markedForDelete}" class="caption">\n        <p>{{ media.fileName }}</p>\n    </div>\n    <div ng-show="markedForDelete" class="overlayer overlayer-text">\n        <div class="overlayer-text-inner">\n            <p>{{ deleteMessage }}</p>\n            <p ng-if="onCancel" class="m-t-10">\n                <button ng-click="cancel($event)" class="btn btn-default">Cancel</button>\n            </p>\n        </div>\n    </div>\n    <div ng-show="onDelete && !markedForDelete" class="overlayer overlayer-btn">\n        <button ng-click="delete($event)" uib-tooltip="{{ tooltip }}" tooltip-append-to-body="true" tooltip-trigger="mouseenter" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i></button>\n    </div>\n</div>\n',
            scope: {
                media: '=',
                onDelete: '&',
                onCancel: '&?',
                tooltip: '@?',
                deleteMessage: '@?',
                markedForDelete: '=?'
            },
            link: function (scope, element, attrs) {
                scope.tooltip = _.isUndefined(scope.tooltip) ? 'Delete image' : scope.tooltip;
                scope.deleteMessage = _.isUndefined(scope.deleteMessage) ? 'This image will be deleted after changes are saved' : scope.deleteMessage;

                scope.delete = function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    scope.onDelete();
                };

                scope.cancel = function ($event) {
                    $event.preventDefault();
                    $event.stopPropagation();

                    scope.onCancel();
                };
            }
        }
    });